import { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";
import SocialButtons from "../common/socialbuttons";
interface FooterProps {}

const Footer: FunctionComponent<FooterProps> = () => {


  return (
    <>
      <footer>
        <div className="parts">
          <div className="primaryInfo footerSectionContainer">
            <div className="logo_container no-select">
              <NavLink to="/">
                <img
                  src="./assets/images/logo.png"
                  alt="logo"
                  className="logo"
                />
              </NavLink>
            </div>
            <div className="pI_descripcion">
              Somos una empresa con amplia experiencia en el rubro de la
              construcción llevando adelante todo tipo de obras. Proyectamos,
              dirigimos y construimos tu sueño para hacerlo realidad. La
              construcción es nuestra pasión, por eso realizamos cada trabajo
              con alto compromiso, garantizando la calidad del mismo.
            </div>
          </div>
          <div className="contactInfo footerSectionContainer">
            <div className="titulo">Contacto</div>
            <div className="cI_descripcion">
              <p>Profesor Mariño 1399, Temperley</p>
              <p>Celular: 1131673437</p>
              <p>
                <a href="mailto:info@dieselconstructora.com.ar">
                  info@dieselconstructora.com.ar
                </a>
              </p>
              <SocialButtons></SocialButtons>
            </div>
          </div>
          <div className="empriseInfo footerSectionContainer">
            <div className="titulo">La empresa</div>
            <div className="links">
              <ul className="items_container">
                <li>
                  <NavLink
                    to="/"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Inicio
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/quienes-somos">Quienes somos</NavLink>
                </li>
                <li>
                  <NavLink to="/nuestros-trabajos">Nuestros trabajos</NavLink>
                </li>
                <li>
                  <NavLink to="/contacto">Contacto</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="signature">
          <p>
            Developed by
            <a href={'https://github.com/TonyHermann/'} target="_blank">
              @TonyHermann
            </a>
            竹
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
